export var OperationLogsCategoryType;
(function (OperationLogsCategoryType) {
    OperationLogsCategoryType["PLAYER_SETTING"] = "player_setting";
    OperationLogsCategoryType["PLAYER_PERMISSION"] = "player_permission";
    OperationLogsCategoryType["PLAYER_INFO"] = "player_info";
    OperationLogsCategoryType["PLAYER_ACCOUNT"] = "player_account";
    OperationLogsCategoryType["CRYPTO_WALLET"] = "crypt_wallet";
    OperationLogsCategoryType["WITHDRAWAL_ACCOUNT"] = "withdrawal_account";
    OperationLogsCategoryType["BANK_CARD"] = "bank_card";
})(OperationLogsCategoryType || (OperationLogsCategoryType = {}));
export var OperationLogsPlayerSettingMethod;
(function (OperationLogsPlayerSettingMethod) {
    OperationLogsPlayerSettingMethod["LOGIN_PASSWORD"] = "\u767B\u5F55\u5BC6\u7801";
    OperationLogsPlayerSettingMethod["SECRET_QUESTION"] = "\u5BC6\u4FDD\u8BBE\u5B9A";
    OperationLogsPlayerSettingMethod["WECHAT_ACCOUNT"] = "\u5FAE\u4FE1\u5E10\u53F7";
    OperationLogsPlayerSettingMethod["QQ_ACCOUNT"] = "QQ\u5E10\u53F7";
    OperationLogsPlayerSettingMethod["BIRTHDAY"] = "\u51FA\u751F\u65E5\u671F";
    OperationLogsPlayerSettingMethod["ADDRESS"] = "\u6536\u8D27\u5730\u5740";
})(OperationLogsPlayerSettingMethod || (OperationLogsPlayerSettingMethod = {}));
export var OperationLogsPlayerPermissionMethod;
(function (OperationLogsPlayerPermissionMethod) {
    OperationLogsPlayerPermissionMethod["FM_WARNING_ACCOUNT"] = "FM \u8B66\u793A";
    OperationLogsPlayerPermissionMethod["RC_WARNING_ACCOUNT"] = "RC \u8B66\u793A";
    OperationLogsPlayerPermissionMethod["FREEZE_ACCOUNT_PWD_WRONG"] = "\u5BC6\u7801\u8F93\u5165\u9519\u8BEF 5 \u6B21";
    OperationLogsPlayerPermissionMethod["IS_FIRST_WITHDRAW_LIMIT"] = "\u4E0B\u70B9\u987B\u7528\u94F6\u884C\u5361";
    OperationLogsPlayerPermissionMethod["IS_RMB_WITHDRAW_LIMIT"] = "\u4EBA\u6C11\u5E01\u4E0B\u70B9\u987B\u7528\u94F6\u884C\u5361";
    OperationLogsPlayerPermissionMethod["SMS_VERIFY_BLOCKED"] = "\u9A8C\u8BC1\u7801\u8F93\u5165\u9519\u8BEF 10 \u6B21";
    OperationLogsPlayerPermissionMethod["FREEZE_ACCOUNT"] = "\u51BB\u7ED3\u5E10\u53F7";
    OperationLogsPlayerPermissionMethod["FORBID_ACTIVITY"] = "\u7981\u6B62\u53C2\u52A0\u6D3B\u52A8";
    OperationLogsPlayerPermissionMethod["FORBID_BET"] = "\u7981\u6B62\u6E38\u620F";
    OperationLogsPlayerPermissionMethod["FORBID_DEPOSIT"] = "\u7981\u6B62\u4E0A\u70B9";
    OperationLogsPlayerPermissionMethod["FORBID_WITHDRAW"] = "\u7981\u6B62\u4E0B\u70B9";
    OperationLogsPlayerPermissionMethod["FORBID_TRANSFER"] = "\u7981\u6B62\u8F6C\u70B9";
    OperationLogsPlayerPermissionMethod["FINANCE_MEMO"] = "FM \u5907\u6CE8";
    OperationLogsPlayerPermissionMethod["BATTLE_FILED_MEMO"] = "CS \u5907\u6CE8";
    OperationLogsPlayerPermissionMethod["RISK_MEMO"] = "RC \u5907\u6CE8";
})(OperationLogsPlayerPermissionMethod || (OperationLogsPlayerPermissionMethod = {}));
export var OperationLogsPlayerInfoMethod;
(function (OperationLogsPlayerInfoMethod) {
    OperationLogsPlayerInfoMethod["CELLPHONE"] = "\u624B\u673A\u53F7\u7801";
    OperationLogsPlayerInfoMethod["NICKNAME"] = "\u4F1A\u5458\u6635\u79F0";
    OperationLogsPlayerInfoMethod["EMAIL"] = "\u7535\u5B50\u4FE1\u7BB1";
    OperationLogsPlayerInfoMethod["BUBBLEID"] = "\u6CE1\u6CE1 ID";
    OperationLogsPlayerInfoMethod["XW"] = "\u7384\u6B66";
})(OperationLogsPlayerInfoMethod || (OperationLogsPlayerInfoMethod = {}));
export var OperationLogsPlayerAccountMethod;
(function (OperationLogsPlayerAccountMethod) {
    OperationLogsPlayerAccountMethod["REGISTER"] = "\u6CE8\u518C";
    OperationLogsPlayerAccountMethod["FORGET_PASSWORD"] = "\u5FD8\u8BB0\u5BC6\u7801";
})(OperationLogsPlayerAccountMethod || (OperationLogsPlayerAccountMethod = {}));
export var OperationLogsCryptoWalletMethod;
(function (OperationLogsCryptoWalletMethod) {
    OperationLogsCryptoWalletMethod["CRYPTO_WALLET"] = "\u94B1\u5305\u4FE1\u606F";
})(OperationLogsCryptoWalletMethod || (OperationLogsCryptoWalletMethod = {}));
export var OperationLogsBankCardMethod;
(function (OperationLogsBankCardMethod) {
    OperationLogsBankCardMethod["DEBIT_CARD"] = "\u94F6\u884C\u5361\u4FE1\u606F";
})(OperationLogsBankCardMethod || (OperationLogsBankCardMethod = {}));
export var OperationLogsWithdrawalAccountMethod;
(function (OperationLogsWithdrawalAccountMethod) {
    OperationLogsWithdrawalAccountMethod["WITHDRAWAL_ACCOUNT"] = "\u5E10\u53F7\u4FE1\u606F";
})(OperationLogsWithdrawalAccountMethod || (OperationLogsWithdrawalAccountMethod = {}));
//# sourceMappingURL=OperationLogsCategoryType.js.map